import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import RiskRegisterUpdateModalSF from './RiskRegisterUpdateModalSF.js'
import './RiskRegister.css'

const RiskRegisterUI = ({ context, errorList, riskRegisterList, onRefreshClick, onPreviousClick, onNextClick,
  riskUpdated, selectedRisk, onRiskRegistersUpdateClick, onRiskRegistersUpdateCancel, year, month, yearMonth
}) =>
  <SuperUserHomePageUI context={context} className='pg_su_rr' topnav='accounts'
    centered={!errorList && !riskRegisterList} page='riskRegister'
  >
    {
      !errorList && !riskRegisterList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      riskRegisterList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Risk Register</b></span>
            </div>
          }
          right={
            <span>
              <Link to='#' onClick={onPreviousClick}>Previous</Link>
              <span className='g_m_left_100' />
              <Link to='#' onClick={onNextClick}>Next</Link>
            </span>
          }
        />

        <div>
          <CardUI className='g_m_bottom_100' title={yearMonth}>
            <table>
              <thead className='g_sticky'>
                <tr className='head'>
                  <th>Name</th>
                  <th>Risk owner</th>
                  <th>Risk status</th>
                  <th>Probability</th>
                  <th>Impact</th>
                  <th>Risk level</th>
                  <th>Risk response</th>
                  <th>Mitigation plan</th>
                  <th>Remarks</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {
                  riskRegisterList && riskRegisterList.map((risk, i) =>
                    <tr className='body' key={i}>
                      <td className='left'>{risk.name}</td>
                      <td className='left'>{risk.ownerUserName}</td>
                      <td className={`left ${risk.status === 'active' ? 'g_error' : 'g_success'}`}>{risk.statusName}</td>
                      <td className='left'>{risk.probability}</td>
                      <td className='left'>{risk.impact}</td>
                      <td className={`left ${risk.riskLevel === 'High' ? 'g_error' : 'g_success'}`}>{risk.riskLevel}</td>
                      <td className={`left ${risk.riskResponse === 'Accept' ? 'g_error' : 'g_success'}`}>{risk.riskResponse}</td>
                      <td className='left'>{risk.mitigationPlan}</td>
                      <td className='left'>{risk.remarks}</td>
                      <td>
                        <span className='icon icon-pencil' onClick={onRiskRegistersUpdateClick} data-code={risk.riskCode} />
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </CardUI>
        </div>
      </div>
    }

    <RiskRegisterUpdateModalSF
      context={context} updateMode={riskUpdated} selectedRisk={selectedRisk} year={year} month={month}
      onCancelClick={onRiskRegistersUpdateCancel} onRefreshClick={onRefreshClick}
    />

  </SuperUserHomePageUI >

export default RiskRegisterUI
